export const RECEIVED_MATCH = 'SPORTRADAR/RECEIVED_MATCH'
export const RECEIVED_LEAGUETABLES = 'SPORTRADAR/RECEIVED_LEAGUETABLES'
export const RECEIVED_PREMATCH = 'SPORTRADAR/RECEIVED_PREMATCH'
export const RECEIVED_LIVE = 'SPORTRADAR/RECEIVED_LIVE'